var React = require('react');

function IntegrationsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 7V3H14V7H10V3H8V7C7 7 6 8 6 9V14.5L9.5 18V21H14.5V18L18 14.5V9C18 8 17 7 16 7Z"}));
}

IntegrationsInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"black"};

module.exports = IntegrationsInline;

IntegrationsInline.default = IntegrationsInline;
